export const SEARCH_RESULT_SECTION_NO_RESULTS_TEST_ID = "search-result-section-no-results";
